import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) =>{
 return(
  data.map(({ fieldName, placeholder, name, formType, validation, className, options, imageDimension, usedFileType, disabledPreviousDateTime }) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType:usedFileType,
    options:options,
    imageDimension: imageDimension,
    disabledPreviousDateTime: disabledPreviousDateTime
  }))
 )
}

export const fields: any = {
  aboutUs: mapFields(drilldownData["aboutUs"]),
  timeline: mapFields(drilldownData["timeline"]),
  welcomeNote: mapFields(drilldownData["welcomeNote"]),
  awardsList: mapFields(
    drilldownData["awardsList"]
  ),
  awardsContent: mapFields(
    drilldownData["awardsContent"]
  ),
  news: mapFields(
    drilldownData["news"]
  ),
  careersContent: mapFields(
    drilldownData["careersContent"]
  ),
  storeLocations: mapFields(
    drilldownData["storeLocations"]
  ),
  contactUs: mapFields(
    drilldownData["contactUs"]
  ),
  contactDetails:mapFields(drilldownData['contactDetails']),
  formDetails:mapFields(drilldownData['formDetails']),
  homePagePopup: mapFields(drilldownData["homePagePopup"]),
  TermsAndConditions: mapFields(drilldownData["TermsAndConditions"]),
  Faqs: mapFields(drilldownData["Faqs"]),
  jobOpportunities: mapFields(drilldownData["jobOpportunities"]),
  baggageGuide: mapFields(drilldownData["baggageGuide"]),
  lagsAndRestrictedItems: mapFields(drilldownData["lagsAndRestrictedItems"]),
  dutyFreeBuyingGuide: mapFields(drilldownData["dutyFreeBuyingGuide"]),
  footerContactInfo: mapFields(drilldownData["footerContactInfo"]),
  privacyPolicy: mapFields(drilldownData["privacyPolicy"]),
  singleCabinLuggagePolicy: mapFields(drilldownData["singleCabinLuggagePolicy"]),
  guidelinesForCheckedinLuggage: mapFields(drilldownData["guidelinesForCheckedinLuggage"]),
  lags: mapFields(drilldownData['lags']),
  restrictedItems: mapFields(drilldownData['restrictedItems']),
  singleCabinLuggagePolicyPageContent: mapFields(drilldownData['singleCabinLuggagePolicyPageContent']),
  singleCabinLuggagePolicyPageImage: mapFields(drilldownData['singleCabinLuggagePolicyPageImage']),
  guidelinesForCheckedinLuggagePageContent: mapFields(drilldownData['guidelinesForCheckedinLuggagePageContent']),
  guidelinesForCheckedinLuggagePageImage: mapFields(drilldownData['guidelinesForCheckedinLuggagePageImage']),
  lagsLiquidItemImage: mapFields(drilldownData['lagsLiquidItemImage']),
  lagsPageContent: mapFields(drilldownData['lagsPageContent']),
  restrictedItemsCheckedInCabinRestrictionsContent: mapFields(drilldownData['restrictedItemsCheckedInCabinRestrictionsContent']),
  restrictedItemsCheckedInCabinRestrictionsImage: mapFields(drilldownData['restrictedItemsCheckedInCabinRestrictionsImage']),
  restrictedItemsCabinOnlyRestrictionsContent: mapFields(drilldownData['restrictedItemsCabinOnlyRestrictionsContent']),
  restrictedItemsCabinOnlyRestrictionsImage: mapFields(drilldownData['restrictedItemsCabinOnlyRestrictionsImage']),
  lagsDisclaimerContent: mapFields(drilldownData['lagsDisclaimerContent']),
  lagsGuidelinesContent: mapFields(drilldownData['lagsGuidelinesContent']),
};
